var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents autocontents"},[_c('goods-class-title',{attrs:{"src":require('@/assets/images/automation.png'),"imgwidth":883}}),_vm._v(" "),_vm._l((_vm.autolist),function(auto,index){return _c('goods-automation-item',{key:index,attrs:{"auto":auto,"index":index}})}),_vm._v(" "),_c('div',{staticClass:"clear"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30910ad9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/GoodsAutomation.vue
// module id = null
// module chunks = 